var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('input',{staticClass:"GCB2-audience-setting-base-input",class:{ focused: _vm.focused },style:({ width: `${_vm.width}px` }),domProps:{"value":_vm.value},on:{"input":_vm.update}})
}
var staticRenderFns = []

export { render, staticRenderFns }